import { Box, Grid, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Link from 'next/link';
import React from 'react';

export const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: '110px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  child1: {
    width: '50%',
    paddingRight: '32px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      paddingRight: 0,
    },
  },
  child2: {
    width: '50%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    [theme.breakpoints.down('xl')]: {
      gridTemplateColumns: '1fr',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    columnGap: '32px',
    rowGap: '15px',
  },
  title: {
    fontFamily: 'Playfair Display !important',
    fontSize: '36px',
    fontStyle: 'normal',
    fontWeight: '700',
    color: '#212121',
    marginBottom: 0,
    lineHeight: '54px',
    [theme.breakpoints.down('xl')]: {
      fontSize: '24px',
      lineHeight: '42px',
    },
  },

  description: {
    color: '#212121',
    fontFamily: 'Lato',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '27px',
    [theme.breakpoints.down('xl')]: {
      fontSize: '14px !important',
      lineHeight: '24px',
    },
  },
  link: {
    color: '#3C8047',
    fontFamily: 'Lato',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '27px',
    paddingLeft: '20px',
    marginBottom: 0,
    [theme.breakpoints.down('xl')]: {
      fontSize: '14px !important',
      lineHeight: '24px',
    },
  },
  linkContainer: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '15px',
    borderBottom: '1px solid #C4C4C4',
  },
}));

const programsLinks = [
  {
    title: 'Private Golf Lessons',
    link: '/programs/private-lessons',
  },
  {
    title: 'Club Fitting',
    link: '/programs/club-fitting',
  },
  {
    title: 'Junior Programs',
    link: '/programs/junior-programs',
  },
  {
    title: 'Women’s Programs ',
    link: '/programs/women-programs',
  },
  {
    title: 'Adult Classes',
    link: '/programs/adult-classes',
  },
];

function GolfPrograms() {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.child1}>
        <Typography className={classes.title}>Golf Programs</Typography>
        <Typography className={classes.description}>
        Learn more about the golf programs that we offer at Baywood Greens!
        </Typography>
      </Box>
      <Box className={classes.child2}>
        {programsLinks.map((program) => (
          <Box key={program.title}>
            <Box className={classes.linkContainer}>
              <Box>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="16"
                  viewBox="0 0 24 16"
                  fill="none"
                >
                  <path
                    d="M23.7071 8.70711C24.0976 8.31658 24.0976 7.68342 23.7071 7.29289L17.3431 0.928932C16.9526 0.538408 16.3195 0.538408 15.9289 0.928932C15.5384 1.31946 15.5384 1.95262 15.9289 2.34315L21.5858 8L15.9289 13.6569C15.5384 14.0474 15.5384 14.6805 15.9289 15.0711C16.3195 15.4616 16.9526 15.4616 17.3431 15.0711L23.7071 8.70711ZM0 9H23V7H0V9Z"
                    fill="#3C8047"
                  />
                </svg>
              </Box>
              <Box>
                <Link href={program.link} style={{textDecoration: "none"}}>
                  <Typography className={classes.link}>
                    {program.title}
                  </Typography>
                </Link>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default GolfPrograms;
